import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9997)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.25 23.92C5.64471 23.92 0.290039 18.5653 0.290039 11.96C0.290039 5.35468 5.64471 0 12.25 0C18.8554 0 24.21 5.35468 24.21 11.96C24.21 18.5653 18.8554 23.92 12.25 23.92ZM12.2496 9.30401L8.59265 15.483H15.9065L12.2496 9.30401ZM12.2496 4.56166L12.25 4.56091H12.2491L12.2496 4.56166ZM4.25 18.0791L12.2496 4.56166L20.25 18.0791H4.25Z"
        fill="#11181C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5438_9997">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
)
